import { defineMessages } from 'react-intl';

export const scope = 'app.containers.LandingLayout';

export default defineMessages({
  navShopNow: {
    id: `${scope}.navShopNow`,
    defaultMessage: 'Nhập hàng ngay',
  },
  navWhyKamereo: {
    id: `${scope}.navWhyKamereo`,
    defaultMessage: 'Tại sao chọn KAMEREO?',
  },
  navSolutions: {
    id: `${scope}.navSolutions`,
    defaultMessage: 'Giải pháp',
  },
  navResources: {
    id: `${scope}.navResources`,
    defaultMessage: 'Tài nguyên',
  },
  navCompany: {
    id: `${scope}.navCompany`,
    defaultMessage: 'Công ty',
  },
  companyItem: {
    id: `${scope}.companyItem`,
    defaultMessage: 'Về công ty',
  },
  signin: {
    id: `${scope}.signin`,
    defaultMessage: 'Đăng nhập',
  },
  signup: {
    id: `${scope}.signup`,
    defaultMessage: 'Đăng ký',
  },
  mobileLoginBannerText: {
    id: `${scope}.mobileLoginBannerText`,
    defaultMessage: 'Đăng nhập để hưởng chính sách đặc biệt',
  },
  mobileAppBannerText: {
    id: `${scope}.mobileAppBannerText`,
    defaultMessage: 'Trải nghiệm tốt và nhiều ưu đãi hơn với ứng dụng KAMEREO',
  },
  mobileAppBannerCta: {
    id: `${scope}.mobileAppBannerCta`,
    defaultMessage: 'Tải ngay',
  },
  contactEmailValue: {
    id: `${scope}.contactEmailValue`,
    defaultMessage: 'info@kamereo.vn',
  },
  contactPhoneValue: {
    id: `${scope}.contactPhoneValue`,
    defaultMessage: '0812 463 727',
  },
  footerTagline: {
    id: `${scope}.footerTagline`,
    defaultMessage: 'Nhà cung ứng toàn diện dành cho doanh nghiệp F&B tại Việt Nam',
  },
  footerEmail: {
    id: `${scope}.footerEmail`,
    defaultMessage: 'Email: info@kamereo.vn',
  },
  footerPhone: {
    id: `${scope}.footerPhone`,
    defaultMessage: 'Số điện thoại: 0812 463 727',
  },
  footerAddressLabel: {
    id: `${scope}.footerAddressLabel`,
    defaultMessage: 'Địa chỉ:',
  },
  footerAddressNorth: {
    id: `${scope}.footerAddressNorth`,
    defaultMessage: 'Miền Bắc: Detech Tower II, 107 Đ. Nguyễn Phong Sắc, Dịch Vọng Hậu, Cầu Giấy, Hà Nội.',
  },
  footerAddressSouth: {
    id: `${scope}.footerAddressSouth`,
    defaultMessage: 'Miền Nam: Tòa nhà The Manor Officetel, 89 Nguyễn Hữu Cảnh, Thạnh Mỹ Tây, TP Hồ Chí Minh.',
  },
  footerColumnProducts: {
    id: `${scope}.footerColumnProducts`,
    defaultMessage: 'Sản phẩm',
  },
  footerShoppingNow: {
    id: `${scope}.footerShoppingNow`,
    defaultMessage: 'Mua hàng',
  },
  footerDistributionLocation: {
    id: `${scope}.footerDistributionLocation`,
    defaultMessage: 'Hệ thống phân phối',
  },
  footerFarmToBusiness: {
    id: `${scope}.footerFarmToBusiness`,
    defaultMessage: 'Tươi từ nông trại',
  },
  footerKamereoFresh: {
    id: `${scope}.footerKamereoFresh`,
    defaultMessage: 'Kamereo Ngon',
  },
  footerKamereoEssential: {
    id: `${scope}.footerKamereoEssential`,
    defaultMessage: 'Kamereo Tiện Dụng',
  },
  footerColumnResources: {
    id: `${scope}.footerColumnResources`,
    defaultMessage: 'Tài nguyên',
  },
  footerBusinessTips: {
    id: `${scope}.footerBusinessTips`,
    defaultMessage: 'Kinh doanh F&B',
  },
  footerFoodLifestyle: {
    id: `${scope}.footerFoodLifestyle`,
    defaultMessage: 'Ẩm thực & đời sống',
  },
  footerTopPlaces: {
    id: `${scope}.footerTopPlaces`,
    defaultMessage: 'Top địa điểm',
  },
  footerCertifications: {
    id: `${scope}.footerCertifications`,
    defaultMessage: 'Chứng nhận',
  },
  footerFreshCommitment: {
    id: `${scope}.footerFreshCommitment`,
    defaultMessage: 'Cam kết tươi mới',
  },
  footerColumnCompany: {
    id: `${scope}.footerColumnCompany`,
    defaultMessage: 'Công ty',
  },
  footerWhatIsKamereo: {
    id: `${scope}.footerWhatIsKamereo`,
    defaultMessage: 'Về công ty',
  },
  footerWhyKamereo: {
    id: `${scope}.footerWhyKamereo`,
    defaultMessage: 'Tại sao chọn Kamereo?',
  },
  footerCareers: {
    id: `${scope}.footerCareers`,
    defaultMessage: 'Tuyển dụng',
  },
  footerCoreValues: {
    id: `${scope}.footerCoreValues`,
    defaultMessage: 'Giá trị cốt lõi',
  },
  footerNews: {
    id: `${scope}.footerNews`,
    defaultMessage: 'Tin tức',
  },
  footerPress: {
    id: `${scope}.footerPress`,
    defaultMessage: 'Báo chí',
  },
  footerColumnSupport: {
    id: `${scope}.footerColumnSupport`,
    defaultMessage: 'Hỗ trợ',
  },
  footerPayment: {
    id: `${scope}.footerPayment`,
    defaultMessage: 'Phương thức thanh toán',
  },
  footerDelivery: {
    id: `${scope}.footerDelivery`,
    defaultMessage: 'Chính sách giao hàng',
  },
  footerExchange: {
    id: `${scope}.footerExchange`,
    defaultMessage: 'Chính sách đổi trả',
  },
  footerTerms: {
    id: `${scope}.footerTerms`,
    defaultMessage: 'Điều khoản sử dụng',
  },
  footerPrivacy: {
    id: `${scope}.footerPrivacy`,
    defaultMessage: 'Chính sách bảo mật',
  },
  footerCopyright: {
    id: `${scope}.footerCopyright`,
    defaultMessage: '© {currentYear} Kamereo. All rights reserved.',
  },
});
